/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EAnalysisStatus } from "../types/EAnalysisStatus.ts";

/**
 * @description 0 = Recognized | 1 = NotRecognized | 2 = SentToAnalysis | 3 = NotAnalyzed |
 */
export const eAnalysisStatusSchema = z
  .union([z.literal(0), z.literal(1), z.literal(2), z.literal(3)])
  .describe(
    "0 = Recognized | 1 = NotRecognized | 2 = SentToAnalysis | 3 = NotAnalyzed | ",
  ) as unknown as ToZod<EAnalysisStatus>;
